import { Button } from '@bepure/tarkin';
import Popup from 'components/Popup';
import React, { useState } from 'react';
import ReactDOM from 'react-dom';



const ShippingReturns = () => {
    const [popupOpen, setPopupOpen] = useState(false)
    
    return(
        <div className="shipping-returns-section">
            <div className="shipping-returns-section__item">
                <img className="shipping-returns-section__item__icon" src="https://s3.ap-southeast-2.amazonaws.com/static.bepure.co.nz/Arwen/Icons/Friends+with+benefits/FWB_heart.svg"/>
                <div className="shipping-returns-section__item__text"> 
                    Become a
                    <a onClick={() => setPopupOpen!(true)} className="clickable"> Friend with Benefits </a>
                    for perky perks and freebies!  
                </div>
            </div>

            <div className="shipping-returns-section__item">
                <img className="shipping-returns-section__item__icon" src="https://s3-ap-southeast-2.amazonaws.com/static.bepure.co.nz/Arwen/EveWellness/Icons/Eve_Shipping_43x27.svg"/>
                <div className="shipping-returns-section__item__text"> Free shipping on all NZ orders </div>
            </div>

            <div className="shipping-returns-section__item">
                <img className="shipping-returns-section__item__icon" src="https://s3-ap-southeast-2.amazonaws.com/static.bepure.co.nz/Arwen/EveWellness/Icons/Eve_Returns_37x35.svg"/>
                <div className="shipping-returns-section__item__text"> 14-day returns. Read our <a href="/terms-and-conditions">Terms & Conditions</a> for more information </div>
            </div>

            <Popup 
                onClose={() => setPopupOpen(false)}
                open={popupOpen}
                imageSrc={{
                    desktopSrc: 'https://s3.ap-southeast-2.amazonaws.com/static.bepure.co.nz/Arwen/Raster_Images/Friends+with+benefits/FWB_PopUp_Desktop_1064x535_150dpi.png',
                    mobileSrc: 'https://s3.ap-southeast-2.amazonaws.com/static.bepure.co.nz/Arwen/Raster_Images/Friends+with+benefits/FWB_PopUp_Mobile_325x567_150dpi.png'
                }}
            >
                <>
                    <p>Read our <a href='/terms-and-conditions'>Terms & Conditions</a> for more information</p>
                    <Button 
                        ariaLabel={"learn more"}
                        text={'LEARN MORE'}
                        onClick={() => window.location.href = '/friends-benefits'}
                    />
                </>
            </Popup>
        </div>
    )
}

export default function render() {
    const elements = document.getElementsByClassName('left-shipping-returns');
    Array.prototype.map.call(elements, (element: HTMLElement) => {
        return ReactDOM.render(<ShippingReturns/>, element);
    });
}